// Angular
import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { NotificationService } from './services/notification.service';

@Component({
	selector: 'kt-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['notification.component.scss']
})
export class NotificationComponent implements OnInit, AfterViewInit, OnDestroy {
	public logsList: any = []
	public taskList: any = [];
	public notificationsCount: any = []
	public alertList: any = [];
	public interval: any;
	public allNotifications:any;
	public notificationSeprateCount:any = {
		task:0,
		alert:0,
		log:0
	};
	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer, private sharedService: SharedService, private notificationService:NotificationService) {
	}

	ngOnInit() {
		setTimeout(()=>{
		this.getNotificationsList(1);
	},1000)
	}

	ngAfterViewInit() {
		this.interval = setInterval(() => {
			this.getNotificationsList(1);
		}, 150000)
	}

	ngOnDestroy() {
		clearInterval(this.interval);
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	public getNotificationsList(page): void {
		let data =
			{ "data": ["DAS", "DES", "CMNPROF","PUCA"] }
	/*	this.sharedService.getUnReadNotifications(data).subscribe(
			(res: HecResponse) => {
				this.taskList = []
				this.alertList = []
				this.logsList = []
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.notificationsCount = res.data.count;
					this.allNotifications = res.data.notificationList
					if(res.data.countByType['703801']){
					this.notificationSeprateCount.alert = res.data.countByType['703801'];
				}
				if(res.data.countByType['703802']){
					this.notificationSeprateCount.log = res.data.countByType['703802'];
				}
				if(res.data.countByType['703803']){
					this.notificationSeprateCount.task = res.data.countByType['703803'];
				}
					res.data.notificationList.forEach(element => {
						if (!element.isRead && element.notificationType == 703803) {
							this.taskList.push(element)
						} else if (!element.isRead && element.notificationType == 703802) {
							this.logsList.push(element)
						}
						else if (!element.isRead && element.notificationType == 703801) {
							this.alertList.push(element)
						}
					});
					if (this.notificationsCount > 0) {
						this.pulse = true;
					}
				}
			}
		)*/
	}

	public getTab(count:number,tabId){
		// this.notificationsCount = this.notificationsCount - count;
	}


	public convertNotificationData(notification) {
		return JSON.parse(notification).data
	}

	public convertTime(datetime) {
		return new Date(datetime)
	}

	public readNotification(notificationId) {
		let data = {
			data: notificationId
		}
		let appType;
		let appId;
		 this.allNotifications.forEach(element => {
				if(element.id == notificationId){
					appType = element.notificationType;
					appId = JSON.parse(element.notification).appId
				}
		});
		this.sharedService.updateNotification(data).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data) {
					this.getNotificationsList(1);
					if(appType != 703802){
					this.goToNotification(appType,appId)
				}
				}
			}
		)
	}

	public goToNotification(notificationType,appId):void{
		this.notificationService.sendNotification(notificationType,appId)
	}
}
